module.exports = {"title":"Mercedes-Benz Fashion Week Russia","description":"Mercedes-Benz Fashion Week Russia. Специальный проект, посвященный новому сезону","image":"https://mbfwr-ss-19.wmj.ru/img/share.png","url":"https://mbfwr-ss-19.wmj.ru/","fbappid":396959934055666,"GTM":"GTM-MQHW53W","top100":0,"clientTop100":0,"yaMetrika":7399345}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 352
// module chunks = 0